<template>
    <modal @close="onClose" ref="modal">
        <template v-slot:title>New backup codes</template>

        <slot>
            <p>Your old backup codes no longer work. Keep these somewhere safe – they won't be shown again.</p>

            <backup-codes-list :codes="codes" class="mb-3" />

            <button-row>
                <button type="button" class="btn btn-primary" data-test="codes-done" @click.prevent="close">Close</button>
            </button-row>
        </slot>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/ModalMixin'
import BackupCodesList from './BackupCodesList'

export default {
    components: {BackupCodesList},
    mixins: [ModalMixin],
    emits: ['close'],
    data() {
        return {
            codes: [],
        }
    },
    methods: {
        // Codes live only in this component, and are dropped when it closes
        show(codes) {
            this.codes = codes
            this.open()
        },
        onClose() {
            this.codes = []
            this.$emit('close')
        },
    },
}
</script>
